<template>
  <div v-if="setVisible" class="rock-table-set flex">
    <el-checkbox
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      class="indeterminate"
      @change="handleCheckAllChange"
      >全选
    </el-checkbox>
    <el-checkbox-group
      v-model="checkedList"
      @change="handleCheckedCitiesChange"
    >
      <el-checkbox
        v-for="column in columns.filter((item) => item.field)"
        :label="column.field"
        :key="column.field"
        :disabled="column.disableCheck"
        >{{ column.title }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "RockTableSet",
  install(Vue) {
    Vue.component("RockTableSet", this);
  },
  props: {
    visible: Boolean,
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      checkAll: undefined,
      checkedList: [],
      isIndeterminate: undefined,
    };
  },
  computed: {
    setVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (this.visible !== val) this.$emit("input", val);
      },
    },
  },
  watch: {
    columns: {
      handler(val) {
        const checkedList = val
          .filter(
            (item) =>
              !Object.prototype.hasOwnProperty.call(item, "visible") ||
              item.visible
          )
          .map((item) => item.field);
        if (this.checkedList !== checkedList) {
          this.checkedList = checkedList;
          // 计算全选和半选
          let checkedCount = this.checkedList.length;
          this.checkAll = checkedCount === val.length;
          this.isIndeterminate = checkedCount > 0 && checkedCount < val.length;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    handleCheckAllChange(val) {
      const newColumns = this._.cloneDeep(this.columns);
      if (val) {
        newColumns.forEach((item) => {
          if (item.disableCheck !== true) this.$delete(item, "visible");
        });
      } else {
        newColumns.forEach((item) => {
          if (item.disableCheck !== true) this.$set(item, "visible", false);
        });
      }
      this.checkedList = newColumns.map((column) => column.field);
      this.$emit("change", newColumns);
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(val) {
      let checkedCount = val.length;
      this.checkAll = checkedCount === this.columns.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.columns.length;

      const newColumns = this._.cloneDeep(this.columns);
      newColumns.forEach((item) => {
        if (!val.includes(item.field)) {
          item.visible = false;
        } else this.$delete(item, "visible");
      });
      this.$emit("change", newColumns);
    },
  },
};
</script>

<style scoped lang="scss">
.rock-table-set {
  box-sizing: border-box;
  padding: 16px;
  width: 100%;
  border: 1px dashed #1768cc;

  .indeterminate {
    margin-right: 30px;
  }
}
</style>
